/* eslint-disable eqeqeq */
import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';

// @mui
import { Box, List, ListItemText } from '@mui/material';
//
import { StyledNavItem, StyledNavItemIcon } from './styles';

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], ...other }) {
  const hasAccess = (screenName) => {
    // console.log('screenName', screenName, 'access', sessionStorage.getItem(`${screenName}`) === 'Y');   
    // Added by Harel
    const isSplUser = sessionStorage.getItem('SplUser') === 'Y';
    const access = sessionStorage.getItem(`${screenName}`) === 'Y';
    return access || isSplUser;
  };
  return (
    <Box {...other}>
      <List disablePadding sx={{ px: 1 }}>
        {data
          .filter((item) => hasAccess(item.ShortName))
          .map((item) => (
            <NavItem key={item.title} item={item} />
          ))}

        {/* {data.map((item) => (
          <NavItem key={item.title} item={item} />
        ))} */}
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info } = item;

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        '&.active': {
          color: '#EEEEEE',
          py: 3,
          // color: 'text.primary',
          bgcolor: '#ffffff4a',
          // bgcolor: 'action.selected',
          fontWeight: 'fontWeightBold',
        },
        mb: 1,
      }}
    >
      <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>

      <ListItemText disableTypography primary={title} sx={{ fontSize: 'small' }} />

      {info && info}
    </StyledNavItem>
  );
}
